import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--townsquare/townsquare-screen-space-flags';

import { type MessageTemplateContext } from '../../..';

import { UniversalCreateButtonSpotlight } from '../../../components/UniversalCreateButtonSpotlight';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps;

export const render: {
	type: 'render';
	validate: (input: unknown) => RenderProps;
	Component: (
		input: PlacementRenderProps & {
			testProp: string;
		},
	) => JSX.Element | null;
} = PlacementFrontend.createFrontendStage({
	type: 'render',
	validate: noValidation<RenderProps>(),
	Component: ({ dismiss }) => {
		return <UniversalCreateButtonSpotlight dismiss={dismiss} />;
	},
});

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render,
});
